const style = {
  body: {
    userSelect: 'none',
    margin: '4px',
    padding: '8px 6px',
    border: '1px solid #c4c4c4',
    backgroundColor: '#ffffff',
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    marginBottom: 4,
  },
  name: {
    color: '#838383',
    marginRight: 5,
  },
  archived: {
    color: '#ee4360',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  date: {
    color: '#838383',
    textAlign: 'center',
    fontSize: 10,
    width: '100%',
  },
  campaignId: {
    color: '#838383',
    fontSize: 10,
    width: '25px',
    cursor: 'pointer',
  },
  rejected: {
    color: 'red',
  },
  campaignName: {
    color: '#ee4360',
    fontSize: 15,
    fontWeight: 600,
  },
  statistics: {
    display: 'flex',
    justifyContent: 'space-around',
    '& div': {
      color: '#838383',
      fontSize: 12,
      padding: 5,
    },
  },
  flyers: {
    display: 'flex',
    justifyContent: 'space-between',
    '& div': {
      color: '#838383',
      fontSize: 12,
      // padding: 0,
    },
  },
}

export default style
